import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Image1 from "../../assets/img/portfolio/portfolio-1.jpg";
import Image2 from "../../assets/img/portfolio/portfolio-2.jpg";
import Image3 from "../../assets/img/portfolio/portfolio-3.jpg";
import Image4 from "../../assets/img/portfolio/portfolio-4.jpg";
import Image5 from "../../assets/img/portfolio/portfolio-5.jpg";
import React from "react";
import Slider from "react-slick";

// Import css files

function PortfolioSlider() {
	const settings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		cssEase: "linear",
		pauseOnHover: true,
		dots: false,
		arrows: false,
	};

	return (
		<Slider {...settings}>
			{/* Portfolio-1 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:ml-auto md:w-1/2 md:pr-10 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-r lg:py-14 h-full'>
					<div className='md:hidden'>
						<img
							className='h-56 bg-gray-600 sm:h-72 w-full object-cover'
							src={Image1}
							alt=''
						/>
					</div>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Pishon Helping Hands - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							Homecare Website
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-16'>
							Pishon Helping Hands is a highly trusted Canadian organization
							dedicated to empowering adults through compassionate care,
							fostering their independence and promoting overall well-being.
						</p>

						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								WordPress | Elementor
							</p>
						</div>

						<div className='mt-4 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://www.pishonhelpinghands.ca/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VIEW WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className='hidden md:block h-56 bg-gray-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image1} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-2 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:ml-auto md:w-1/2 md:pr-10 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-r lg:py-14 h-full'>
					<div className='md:hidden'>
						<img
							className='h-56 bg-gray-600 sm:h-72 w-full object-cover'
							src={Image2}
							alt=''
						/>
					</div>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							BiteExpress Merch - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							Online Store
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-16'>
							Explore BiteExpress Merch for a wide array of exclusive designs
							and premium products. Count on us for reliable service that
							perfectly matches your unique style preferences. Start shopping
							with us today!
						</p>
						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								WordPress | Elementor | WooCommerce
							</p>
						</div>

						<div className='mt-4 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://store.biteexpress.ng/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VIEW WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className='hidden md:block h-56 bg-gray-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image2} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-3 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:ml-auto md:w-1/2 md:pr-10 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-r lg:py-14 h-full'>
					<div className='md:hidden'>
						<img
							className='h-56 bg-gray-600 sm:h-72 w-full object-cover'
							src={Image3}
							alt=''
						/>
					</div>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Pharmxtra - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							Healthcare Hub
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-16'>
							Pharmxtra is a healthcare-oriented organization committed to
							delivering quality services with a focus on customer satisfaction.
							Our goal is to ensure the utmost contentment of our esteemed
							clients.
						</p>

						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								WordPress | Elementor | WooCommerce
							</p>
						</div>

						<div className='mt-4 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://www.pharmxtraservices.com/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VIEW WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className='hidden md:block h-56 bg-gray-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image3} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-4 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:ml-auto md:w-1/2 md:pr-10 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-r lg:py-14 h-full'>
					<div className='md:hidden'>
						<img
							className='h-56 bg-gray-600 sm:h-72 w-full object-cover'
							src={Image4}
							alt=''
						/>
					</div>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							Manna Academy - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							Education Platform
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-16'>
							Manna Academy is dedicated to igniting the minds of students and
							inspiring them for bright futures. With a focus on academic
							excellence and character development, we nurture their potential.
						</p>

						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								WordPress | Elementor | Laravel | PHP | MySQL
							</p>
						</div>

						<div className='mt-4 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://www.mannaacademy.sch.ng/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VIEW WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className='hidden md:block h-56 bg-gray-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image4} alt='' />
					</div>
				</div>
			</div>

			{/* Portfolio-5 */}
			<div className='relative bg-transparent mt-8'>
				<div className='md:flex md:items-center md:ml-auto md:w-1/2 md:pr-10 md:pl-10 md:border-gray-400 md:border-t md:border-b md:border-r lg:py-14 h-full'>
					<div className='md:hidden'>
						<img
							className='h-56 bg-gray-600 sm:h-72 w-full object-cover'
							src={Image5}
							alt=''
						/>
					</div>
					<div>
						<h2 className='text-lg font-semibold text-gray-900 text-center md:text-left mt-5 md:mt-0'>
							BiteExpress - Website Design
						</h2>

						<p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
							Food Delivery Website
						</p>
						<p className='mt-3 text-lg text-gray-600 md:pr-16'>
							BiteExpress offers fast and flavorful food delivery, bringing your
							favorite meals right to your doorstep. With a wide selection
							restaurants to choose from, ordering is quick and convenient.
						</p>

						<div className='mt-4'>
							<h6 className='text-sm font-medium text-gray-900'>
								Frameworks/Languages Used:
							</h6>
							<p className='text-sm text-gray-600 md:pr-32'>
								Reactjs | TailwindCSS
							</p>
						</div>

						<div className='mt-4 text-center md:text-left'>
							<div className='inline-flex'>
								<div className='md:w-auto w-full justify-center md:justify-start'>
									<a
										href='https://biteexpress.ng/'
										target='blank'
										className='inline-flex items-center rounded-md border border-transparent py-3 text-base font-semibold text-gray-900'>
										VIEW WEBSITE
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='1.5'
											stroke='White'
											className='h-8 w-8 text-white bg-gray-900 rounded-full p-2 ml-4'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25'></path>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>

					<div className='hidden md:block h-56 bg-gray-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2'>
						<img className='h-full w-full object-cover' src={Image5} alt='' />
					</div>
				</div>
			</div>
		</Slider>
	);
}

export default PortfolioSlider;
